import React, { useState } from "react";
import Navbar      from "./components/Navbar";
import Footer      from "./components/Footer";
import HomePage    from "./pages/HomePage";
import AboutPage   from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import WorkPage    from "./pages/WorkPage";
import ContactPage from "./pages/ContactPage";

const GLOBAL_CSS = `
  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }
  html { scroll-behavior: smooth; font-size: 16px; }
  body { background: #FFFFFF; color: #1A1A1A; -webkit-font-smoothing: antialiased; }

  ::selection { background: rgba(212,41,42,0.14); color: #0A0A0A; }
  ::-webkit-scrollbar { width: 4px; }
  ::-webkit-scrollbar-track { background: #f0f0f0; }
  ::-webkit-scrollbar-thumb { background: #D4292A; }

  @keyframes marqueeTicker {
    0%   { transform: translateX(0); }
    100% { transform: translateX(-33.333%); }
  }
  @keyframes scrollLine {
    0%, 100% { opacity: 0.4; transform: scaleY(1); }
    50%       { opacity: 1;   transform: scaleY(1.14); }
  }
  @keyframes pageIn {
    from { opacity: 0; transform: translateY(18px); }
    to   { opacity: 1; transform: none; }
  }

  /* ── LAYOUT CLASSES ── */
  .tp-split        { display: grid; grid-template-columns: 1fr 1fr; }
  .tp-3col         { display: grid; grid-template-columns: repeat(3, 1fr); gap: 3px; }
  .tp-stats-band   { display: grid; grid-template-columns: repeat(4, 1fr); }
  .tp-process-grid { display: grid; grid-template-columns: repeat(4, 1fr); }
  .tp-form2        { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; }
  .tp-stats-float  { display: block; }

  /* Footer grid */
  .tp-footer-grid {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr 1.5fr;
    gap: 60px;
    margin-bottom: 64px;
  }

  /* Desktop nav visible, mobile hidden */
  .tp-desktop-nav { display: flex !important; }
  .tp-mobile-btn  { display: none !important; }

  /* ── RESPONSIVE ── */
  @media (max-width: 1100px) {
    .tp-stats-band   { grid-template-columns: repeat(2, 1fr) !important; }
    .tp-footer-grid  { grid-template-columns: 1fr 1fr !important; gap: 40px !important; }
    .tp-process-grid { grid-template-columns: repeat(2, 1fr) !important; }
    .tp-stats-float  { display: none !important; }
  }

  @media (max-width: 820px) {
    .tp-desktop-nav { display: none !important; }
    .tp-mobile-btn  { display: flex !important; }
    .tp-split       { grid-template-columns: 1fr !important; }
    .tp-3col        { grid-template-columns: 1fr 1fr !important; }
    .tp-form2       { grid-template-columns: 1fr !important; }
  }

  @media (max-width: 520px) {
    .tp-3col        { grid-template-columns: 1fr !important; }
    .tp-stats-band  { grid-template-columns: 1fr 1fr !important; }
    .tp-footer-grid { grid-template-columns: 1fr !important; }
    .tp-process-grid { grid-template-columns: 1fr !important; }
  }
`;

const PAGES = {
  home:     HomePage,
  about:    AboutPage,
  services: ServicesPage,
  work:     WorkPage,
  contact:  ContactPage,
};

export default function App() {
  const [page, setPage] = useState("home");
  const PageComponent   = PAGES[page] || HomePage;

  return (
    <div style={{ minHeight: "100vh", background: "#FFFFFF" }}>
      <style>{GLOBAL_CSS}</style>
      <Navbar page={page} setPage={setPage} />
      <main key={page} style={{ animation: "pageIn 0.48s cubic-bezier(0.22,1,0.36,1)" }}>
        <PageComponent setPage={setPage} />
      </main>
      <Footer setPage={setPage} />
    </div>
  );
}
